import React from "react";
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import WeekDaysHeader from "./components/WeekDaysHeader";
import DaysContent from "./components/DaysContent";
import styles from "./styles";

const useStyles = makeStyles(styles);

const Calendar = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <WeekDaysHeader classes={classes} />
      <DaysContent classes={classes} {...props} />
    </Box>
  );
};

export default Calendar;
